import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { scrollTo } from "./Nav";

const VIDEO_SRC = "https://assets.mixkit.co/videos/47286/47286-720.mp4";
const POSTER =
  "https://images.unsplash.com/photo-1741850419928-aa65b3d5e3a6?fm=jpg&q=80&w=2000&auto=format&fit=crop";

export const DroneVideo = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} id="drone" className="relative min-h-[85vh] overflow-hidden grain" data-testid="drone-section">
      <motion.video
        style={{ y, scale: 1.18 }}
        autoPlay
        muted
        loop
        playsInline
        poster={POSTER}
        className="absolute inset-0 h-full w-full object-cover will-change-transform"
        data-testid="drone-video"
      >
        <source src={VIDEO_SRC} type="video/mp4" />
      </motion.video>
      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0F12] via-transparent to-[#0D0F12]/60" />

      <div className="relative z-10 mx-auto flex h-full min-h-[85vh] max-w-7xl flex-col justify-end px-6 pb-20 pt-28 lg:px-12 lg:pb-24">
        <Reveal>
          <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]" data-testid="drone-overline">
            {t("drone.overline")}
          </p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-light leading-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl" data-testid="drone-heading">
            {t("drone.h2pre")} <em className="italic text-[#D6705A]">{t("drone.h2em")}</em>.
          </h2>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-[#C9C7C3] md:text-base" data-testid="drone-text">
            {t("drone.text")}
          </p>
          <button
            onClick={() => scrollTo("#prenota")}
            className="mt-8 rounded-full border border-white/25 px-8 py-4 font-code text-[11px] uppercase tracking-[0.25em] text-[#F9F8F6] transition-[border-color,background-color,transform] duration-300 hover:border-[#D6705A] hover:bg-[#D6705A]/10 hover:-translate-y-1"
            data-testid="drone-cta"
          >
            {t("drone.cta")}
          </button>
        </Reveal>
      </div>
    </section>
  );
};
